module.exports = __webpack_public_path__ + "media/images/menu-saved-queries-active-icon-cdd444e333ccb56d18d0616289861af8.svg";